import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

import Loading from '../../Common/components/Loading';
import './Gallery.css';
import GalleryPreviewImage from './GalleryPreviewImage';
import fullLogo from './white_logo.png';
import usePersonalGalleryInteractions from './hooks/usePersonalGalleryInteractions';

export default function PersonalGallery() {
    const { slug } = useParams();
    const {
        gallery,
        isLoading,
        delayed,
        expandedIndex,
        setExpandedIndex,
        swipeHandlers,
        loadedPhotos,
        getNewPage,
    } = usePersonalGalleryInteractions(slug || '');

    if (!gallery && !isLoading) {
        return (
            <div>
                <h3>gallery not found...</h3>
            </div>
        );
    }

    return (
        <div className="Gallery-view">
            <div>
                <Loading isLoading={isLoading} />
                <div
                    className={`Gallery-header ${
                        expandedIndex > -1 ? 'hidden' : ''
                    }`}
                >
                    <div className="Gallery-header-title">
                        <img src={fullLogo} alt="Smilebooth Logo" />
                    </div>
                    <div className="Find-your-own-photos"></div>
                    <div className="Gallery-name"></div>
                </div>
                <div className="Gallery-content" id="galleryContainer">
                    <div className="Gallery-grid-container">
                        <div
                            {...swipeHandlers}
                            className={`Gallery-grid ${delayed ? '' : 'hide'}`}
                        >
                            <InfiniteScroll
                                dataLength={loadedPhotos.length}
                                next={() => getNewPage(10)}
                                style={{
                                    display: 'grid',
                                }}
                                hasMore={gallery.length > loadedPhotos.length}
                                loader={<Loading isLoading={true} />}
                                scrollThreshold="200px"
                                scrollableTarget="galleryContainer"
                            >
                                {gallery.map((photo, index) => {
                                    return (
                                        <GalleryPreviewImage
                                            media={photo}
                                            key={photo.shareIdentifier}
                                            isExpanded={expandedIndex === index}
                                            setExpandedIndex={setExpandedIndex}
                                            index={index}
                                        />
                                    );
                                })}
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
